import { render, staticRenderFns } from "./finance-post-btn.vue?vue&type=template&id=424c8c7a&"
import script from "./finance-post-btn.vue?vue&type=script&lang=js&"
export * from "./finance-post-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports